'use client';

import { waitForCookie } from '@hc-frontend/core-utils-dom';
import { useEffect } from 'react';

import updateSession from '../../actions/update-session-action/update-session-action';

export default function FacebookPixelClient() {
  useEffect(() => {
    Promise.all([
      // Attempt to retrieve Facebook cookies for 10 seconds, after that
      // send the available values to Session Manager
      waitForCookie({ name: '_fbp', timeout: 10_000 }),
      waitForCookie({ name: '_fbc', timeout: 10_000 }),
    ]).then(([fbp, fbc]) => {
      const keys = [];
      if (fbp) {
        keys.push({
          Name: '_fbp',
          Value: fbp,
        });
      }
      if (fbc) {
        keys.push({
          Name: '_fbc',
          Value: fbc,
        });
      }
      if (keys.length > 0) {
        updateSession({
          TrafficContext: {
            Keys: keys,
          },
        });
      }
    });
  }, []);

  return null;
}
